import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { InternalGrid, ThemeDefault } from '@paygreen/paygreen-ui';
import { getNumberFromMediaQuery } from '../../../utils/tools';
import { useNodeDimensions } from '../../../utils/hooks';

export const BorderBottom = styled.div`
    height: ${(props) => props.theme.radius.lg};
    border-radius: 0 0 ${(props) => props.theme.radius.md}
        ${(props) => props.theme.radius.md};

    background-color: ${(props) => props.theme.color.quaternary.light};
`;

export const PartnershipCardGrid = ({ children }) => {
    // we create a ref to detect if component is mounted
    const isMounted = useRef(false);

    // we create a ref using a special hook to get width from InternalGrid component
    const [ref, { width }] = useNodeDimensions(isMounted.current);

    useEffect(() => {
        isMounted.current = true;

        return () => {
            isMounted.current = false;
        };
    }, []);

    return (
        <div ref={ref}>
            <InternalGrid
                displayType="grid"
                gridGap="lg"
                justifyItems="stretch"
                alignItems="flex-start"
                childrenMarginTop="xs"
                childrenMarginBottom="xs"
                gridTemplateColumns={
                    width > getNumberFromMediaQuery(ThemeDefault.screen.max.lg)
                        ? 'repeat(3, 1fr)'
                        : width >
                          getNumberFromMediaQuery(ThemeDefault.screen.max.md)
                        ? 'repeat(2, 1fr)'
                        : '1fr'
                }
            >
                {children}
            </InternalGrid>
        </div>
    );
};

PartnershipCardGrid.propTypes = {
    children: PropTypes.node,
};
